module.exports = __webpack_public_path__ + "static/img/priceInquriy2.d6bb3daf.png";